// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__OA1Iw","edit":"Badge_edit__Tnga-"};